import React from 'react';
import { useReveal } from '../lib/useReveal';
const COST_DATA = [{
  without: 'Años sintiendo el llamado sin formación completa',
  cost: 'Tiempo que no vuelve'
}, {
  without: 'Cursos sueltos que no conectan',
  cost: 'Dinero gastado sin estructura real'
}, {
  without: 'Sin certificado oficial',
  cost: 'Clientes que dudan — precios que bajan'
}, {
  without: 'Sin protocolo de sintonizaciones',
  cost: 'Inseguridad en el momento más importante'
}, {
  without: 'Sin sistema de profesionalización',
  cost: 'Ingresos que no llegan'
}, {
  without: 'El mismo ciclo de postergación',
  cost: 'El próximo año — igual que este'
}];
export function CostComparisonSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#f3e9f7] py-12 md:py-16 px-5 sm:px-6 border-t border-[#e8d5f0]" data-id="element-130">
      <div className="container mx-auto max-w-3xl" data-id="element-131">
        <div ref={ref1} className={`reveal ${vis1 ? 'is-visible' : ''}`} data-id="element-132">
          <div className="text-center mb-10" data-id="element-133">
            <h2 className="text-2xl md:text-4xl font-bold text-[#3d2a5f] mb-4" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-134">
              ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
            </h2>
          </div>

          <div className="bg-white rounded-2xl border border-[#e8d5f0] overflow-hidden shadow-sm" data-id="element-135">
            <div className="grid grid-cols-2 bg-[#faf5fc] border-b border-[#e8d5f0]" data-id="element-136">
              <div className="p-4 md:p-5 text-center" data-id="element-137">
                <span className="text-[#6b5a85] font-bold text-sm uppercase tracking-wider" data-id="element-138">
                  Sin MegaPack
                </span>
              </div>
              <div className="p-4 md:p-5 text-center border-l border-[#e8d5f0]" data-id="element-139">
                <span className="text-red-400 font-bold text-sm uppercase tracking-wider" data-id="element-140">
                  Costo real
                </span>
              </div>
            </div>

            <div className="divide-y divide-[#e8d5f0]" data-id="element-141">
              {COST_DATA.map((row, idx) => <div key={idx} className="grid grid-cols-2 hover:bg-[#faf5fc] transition-colors" data-id="element-142">
                  <div className="p-4 md:p-5 flex items-center justify-center text-center" data-id="element-143">
                    <span className="text-[#3d2a5f] text-sm font-medium" data-id="element-144">
                      {row.without}
                    </span>
                  </div>
                  <div className="p-4 md:p-5 border-l border-[#e8d5f0] flex items-center justify-center text-center bg-red-50/50" data-id="element-145">
                    <span className="text-red-500 font-medium text-sm" data-id="element-146">
                      {row.cost}
                    </span>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}